<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div mat-dialog-title>
  <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Select Project Control Item</h2>
</div>
<div mat-dialog-content>
  <p-table [value]="projectControlItems"
                   #table
                   [rows]="100"
                   [paginator]="true"
                   [pageLinks]="3"
                   [rowsPerPageOptions]="[10, 20, 50, 100]"
                   sortField="controlItem.complianceAreaControlId"
                   dataKey="controlItem.category"
                   selectionMode="single"
           (onSort)="updateRowGroupMetaData()"
           (onFilter)="updateRowGroupMetaData()"
            >

    <ng-template pTemplate="header">
      <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
        <th *ngFor="let col of cols" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                      ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th *ngFor="let col of cols" [ngSwitch]="col.field">
          <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                 (input)="table.filter($event.target['value'], col.field, 'contains')">
          <span *ngSwitchCase="'date'"></span>
          <p-multiSelect *ngSwitchCase="'controlItem.category'" multiple
                         [style]="{'width':'100%'}"
                         (onChange)="table.filter($event.value, 'state', 'in')"></p-multiSelect>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
      <tr class="ui-widget-header"
          *ngIf="rowGroupMetadata && rowGroupMetadata[item.controlItem.category].index === rowIndex">
        <td colspan="6">
          <a href="#" [pRowToggler]="item">
            <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
            <span>{{item['controlItem'].complianceArea.name}} - {{item['controlItem'].category}}</span>
          </a>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
      <tr (click)="selectProjectControlItem(item)">
        <td><span href="#" *ngIf="item.subItems?.length"
                  (click)="$event.stopPropagation();$event.preventDefault();subVisible[item.projectControlItemId] = !subVisible[item.projectControlItemId]"
                  style="margin-left: 14px;">
            <i
              [ngClass]="subVisible[item.projectControlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
          </span>{{item.controlItem.hasParent ? item.controlItem.complianceAreaControlId : item.controlItem.complianceAreaControlId}}
        </td>
        <td>{{item.controlItem.category}}</td>
        <td>{{item.controlItem?.description}}</td>
        <td>
          {{getFullName(item.assignedClient)}}
        </td>
        <td>{{recurringList[item.recurring]}}</td>
        <td>{{item.dueDate | date:'MM/dd/yyyy'}}</td>
      </tr>
      <ng-container *ngIf="subVisible[item.projectControlItemId] && item.controlItem.complianceArea.hasLevels">
        <ng-container *ngFor="let subItemLevel of item.subItemLevels">
          <tr>
            <td [attr.colspan]="6" style="padding-left: 30px;">
            <span href="#" *ngIf="item.subItems?.length"
                  (click)="subVisible[item.projectConjtrolItem + '_' + subItemLevel.level] = !subVisible[item.projectConjtrolItem + '_' + subItemLevel.level]; $event.preventDefault()">
              <i
                [ngClass]="subVisible[item.projectConjtrolItem + '_' + subItemLevel.level] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
            </span>
              {{subItemLevel.level}}</td>
          </tr>

          <ng-container *ngIf="subVisible[item.projectConjtrolItem + '_' + subItemLevel.level]">
            <tr *ngFor="let subIitem of item.subItems" (click)="selectProjectControlItem(subIitem)">
              <td style="padding-left: 40px;">{{subIitem.controlItem.complianceAreaControlId}}</td>
              <td>{{subIitem.controlItem.category}}</td>
              <td>{{subIitem?.controlItem.description}}</td>
              <td>
                {{getFullName(subIitem.assignedClient)}}
              </td>
              <td>{{recurringList[subIitem.recurring]}}</td>
              <td>{{subIitem.dueDate | date:'MM/dd/yyyy'}}
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="subVisible[item.projectControlItemId] && !item.controlItem.complianceArea.hasLevels">
        <tr *ngFor="let subIitem of item.subItems" (click)="selectProjectControlItem(subIitem)">
          <td style="padding-left: 40px;">{{subIitem.controlItem.complianceAreaControlId}}</td>
          <td>{{subIitem.controlItem.category}}</td>
          <td>{{subIitem?.controlItem.description}}</td>
          <td>
            {{getFullName(subIitem.assignedClient)}}
          </td>
          <td>{{recurringList[subIitem.recurring]}}</td>
          <td>{{subIitem.dueDate | date:'MM/dd/yyyy'}}
          </td>
        </tr>
      </ng-container>
    </ng-template>
      </p-table>
</div>
